// @flow

import React, { type Node, useMemo } from 'react';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { IfFeature } from '@tectonics/prs/feature';
import { SelectedCardBrandProvider } from '@tectonics/look-and-feel/commons/selected-card-brand';
import { detectCardBrand } from '@tectonics/prs/card-brand';
import { InputCardHolderName } from './input-card-holder-name';
import { InputCardNumber } from './input-card-number';
import { InputCardExpiryDate } from './input-card-expiry-date';
import { InputCardSecurityCode } from './input-card-security-code';
import { InputCardInstalments } from './input-card-instalments';

export function CreditCardForm(): Node {
  const allFeatures = useAllFeatures();

  const [cardNumber] = useUserInputValue('cardNumber');
  const cardBrand = useMemo(() => {
    return detectCardBrand(cardNumber);
  }, [cardNumber]);

  return (
    <SelectedCardBrandProvider cardBrand={cardBrand}>
      <IfFeature allFeatures={allFeatures} wanted="field_card_holder_name">
        <InputCardHolderName />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_card_number">
        <InputCardNumber />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_card_expiry_date">
        <InputCardExpiryDate />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_card_security_code">
        <InputCardSecurityCode />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_card_instalments">
        <InputCardInstalments />
      </IfFeature>
    </SelectedCardBrandProvider>
  );
}
